const addPx = {};

const propsPx = `
  left top right bottom width height
`
  .trim()
  .split(/\s+/)
  .forEach(i => (addPx[i] = i));

const isTouch = 'ontouchstart' in document.documentElement;

function isIE11() {
  var ua = window.navigator.userAgent;
  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) > 0;
  }
}

const dom = {
  isIE11: isIE11(),
  orientation() {
    document.body.classList.remove('is-landscape');

    const orient = window.innerWidth > window.innerHeight ? 'l' : 'p';

    if (orient === 'l' && window.isMobile.any) {
      document.body.classList.add('is-landscape');
    }
    return orient;
  },
  innerWidth() {
    return window.isMobile.any ? window.screen.width : window.innerWidth;
    // let w =
    //   this.orientation() === 'l' ? window.screen.height : window.screen.width;
    // return window.isMobile.any ? w : window.innerWidth;
  },
  innerHeight() {
    return window.isMobile.any ? window.screen.height : window.innerHeight;
    // let h =
    //   this.orientation() === 'l' ? window.screen.width : window.screen.height;
    // return window.isMobile.any ? h : window.innerHeight;
  },
  // @TODO consider frozen vars for these
  clickOrTouchEnd() {
    return isTouch ? 'touchend' : 'click';
  },
  downOrTouchStart() {
    return isTouch ? 'touchstart' : 'mousedown';
  },
  moveOrTouchMove() {
    return isTouch ? 'touchmove' : 'mousemove';
  },
  upOrTouchEnd() {
    return isTouch ? 'touchend' : 'mouseup';
  },
  touchify(e) {
    const touches = e.touches;
    let pageX;
    let pageY;
    if (touches != null && touches.length > 0) {
      pageX = touches[0].pageX;
      pageY = touches[0].pageY;
    } else {
      pageX = e.pageX;
      pageY = e.pageY;
    }
    return { pageX, pageY };
  },

  els: {},
  grab() {
    const els = document.querySelectorAll('[data-el]');
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      const name = els[i].dataset.el;
      this.els[name] = els[i];
    }
  },

  attrs(el, attrs) {
    for (let i in attrs) {
      el.setAttribute(i, attrs[i]);
    }
    return dom;
  },

  // quickly set styles on element
  style(el, style) {
    for (let i in style) {
      let val = style[i];
      if (typeof val === 'number' && addPx[i]) {
        val = `${val}px`;
      }
      el.style[i] = val;
    }
  }
};

export { dom };
